import { render } from "./RoleData.vue?vue&type=template&id=cf9504dc"
import script from "./RoleData.vue?vue&type=script&lang=js"
export * from "./RoleData.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__